import { useStatsigClient } from '@statsig/react-bindings'

import useDynamicFeatureTogglesStore from './stores/useDynamicFeatureTogglesStore'

const useDynamicFeatureToggles = () => {
   const dynamicFeatureTogglesStore = useDynamicFeatureTogglesStore()

   const client = useStatsigClient()

   const getDynamicConfig = (key: string): Record<string, any> => {
      const hasDynamicConfig = dynamicFeatureTogglesStore.hasDynamicConfig(key)
      if (hasDynamicConfig) {
         return dynamicFeatureTogglesStore.getDynamicConfig(key)
      }

      const dynamicConfig = client.getDynamicConfig(key)
      dynamicFeatureTogglesStore.addDynamicConfig(key, dynamicConfig)
      return dynamicConfig
   }

   const checkGate = (gateName: string): boolean => client.checkGate(gateName)

   return {
      getDynamicConfig,
      checkGate
   }
}

export default useDynamicFeatureToggles
